import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { InventoryMovementOperationsPanelComponent } from './inventory-movement-operations-panel.component';

@Component({
  standalone: true,
  selector: 'ain-offering-inventory-movements-panel',
  imports: [InventoryMovementOperationsPanelComponent],
  template: `
    <ain-inventory-movement-operations-panel
      #operations
      [fixedOfferingId]="offeringId"
      (inventoryChanged)="inventoryChanged.emit()" />
  `
})
export class OfferingInventoryMovementsPanelComponent {
  @Input({ required: true }) offeringId!: string;
  @Output() inventoryChanged = new EventEmitter<void>();

  @ViewChild('operations') private operations?: InventoryMovementOperationsPanelComponent;

  openOperationDialog(): void {
    this.operations?.openOperationDialog();
  }
}
